module.exports = "../images/chosen-sprite.png";